// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__-2lLU","title":"styles_title__jCLao","overviewTable":"styles_overviewTable__bAbMp","smallCol":"styles_smallCol__c4C3b"};